import { Exercise } from './LearnTypes';
import { Lesson } from './Lesson';

export type DailyQuestType = 'word-randomizer' | string;

export interface DailyQuest {
  id: string;
  name: string;
  description: string;
  type: DailyQuestType;
  requiredWordCount: number;
  bonusXP: number;
  lesson?: Lesson;
  lastCompletedAt?: Date | null;
  isAvailable: boolean;
}

export interface DailyQuestActivity {
  id?: string;
  userId: string;
  questId: string;
  questType: DailyQuestType;
  completedAt: Date;
  xpEarned: number;
  bonusXP: number;
  isPerfectLesson?: boolean;
}

export const DAILY_QUESTS: Omit<DailyQuest, 'lesson' | 'lastCompletedAt' | 'isAvailable'>[] = [
  {
    id: 'word-randomizer',
    name: 'Word Randomizer',
    description: 'Practice 8 random words from your active lessons',
    type: 'word-randomizer',
    requiredWordCount: 8,
    bonusXP: 25,
  }
];
